import { render, staticRenderFns } from "./controlPlatform.vue?vue&type=template&id=17112b2c&scoped=true"
import script from "./controlPlatform.vue?vue&type=script&lang=js"
export * from "./controlPlatform.vue?vue&type=script&lang=js"
import style0 from "./controlPlatform.vue?vue&type=style&index=0&id=17112b2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17112b2c",
  null
  
)

export default component.exports